var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "productNumberOfShopMain",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.removeDialog($event)
        }
      }
    },
    [
      _c("div", { staticClass: "frame" }, [
        _c("p", { staticStyle: { width: "100%", "text-align": "center" } }, [
          _vm._v("产品数量")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "horizonGully" }),
        _vm._v(" "),
        _c("div", { staticClass: "horizonDivider" }),
        _vm._v(" "),
        _c("div", { staticClass: "horizonGully" }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.number,
              expression: "number"
            }
          ],
          staticStyle: { width: "100%", "text-align": "center" },
          domProps: { value: _vm.number },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.number = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "horizonGully" }),
        _vm._v(" "),
        _c("div", { staticClass: "horizonDivider" }),
        _vm._v(" "),
        _c("div", { staticClass: "horizonGully" }),
        _vm._v(" "),
        _c(
          "button",
          { staticStyle: { width: "100%" }, on: { click: _vm.confirm } },
          [_vm._v("确认")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "horizonGully" }),
        _vm._v(" "),
        _c(
          "button",
          { staticStyle: { width: "100%" }, on: { click: _vm.removeDialog } },
          [_vm._v("取消")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }